import { Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'genesis-frontend-recommendation-card-tag',
    templateUrl: './recommendation-card-tag.component.html',
    styleUrls: ['./recommendation-card-tag.component.scss']
})
export class RecommendationCardTagComponent {
    @Input() id = '';
    @Input() showTag = false;
    @Input() tagLabel = '';
    @Input() tag = '';
    @Input() size: 'small' | 'medium' = 'small';
    @Input() category: 'urgent' | 'informative' = 'informative';
    @Input() variant: 'attention' | 'verification' | 'completed' | 'new' | 'overdue' | 'missed' | 'neutral' = 'completed';

    @HostBinding('class') class = 'recommendation-card-tag';
}
